export default __webpack_public_path__ + "static/media/chart.1b937154.svg";